module.exports = __webpack_public_path__ + "img/u2369_div.97f83209.png";